import request from '@/utils/request'

const api = {
  // 获取登录用户权限树
  getRolePermissionTrees (params) {
    return request({ url: '/v1/api/identity-admin/user/current/roles', method: 'get', params })
  },
  login(data) {
    return request({ url: '/v1/api/identity-admin/user/passwordLogin', method: 'post', data })
  },
  codeLogin(data) {
    return request({ url: '/v1/api/identity-admin/user/code_login', method: 'post', data })
  },
  getSmsCode(params) {
    return request({ url: '/v1/api/identity-admin/user/sms_code', method: 'get', params })
  },
  logout() {
    return request({ url: '/v1/api/identity-admin/user/logout', method: 'get' })
  },
  getUserInfo() {
    return request({ url: '/v1/api/identity-admin/user/current', method: 'get' })
  },
  getWorkbenchs() {
    return request({ url: '/v1/api/identity-admin/application/operationList', method: 'get' })
  }
}

export default api
